import { useMemo } from 'react';

import { usePMyFunctionalPermissionsQuery } from './graphql/queries/generated/p_MyFunctionalPermissions.productivity';
import { FunctionalPermission } from './types';

export const useFunctionalPermissions = () => {
  const [{ data, fetching, error }] = usePMyFunctionalPermissionsQuery({
    requestPolicy: 'cache-first',
  });

  return useMemo(() => {
    const permissions = data?.myFunctionalPermissions?.filter(
      (permission): permission is string => !!permission,
    );

    const hasPermission = (permission: FunctionalPermission) => {
      // While loading or on transport error we cannot know; don't lock the user out.
      if (!permissions) {
        return true;
      }
      return permissions.includes(permission);
    };

    return { fetching, error, hasPermission };
  }, [data, fetching, error]);
};

export const useFunctionalPermission = (permission: FunctionalPermission) => {
  const { hasPermission } = useFunctionalPermissions();

  return hasPermission(permission);
};

export { FunctionalPermission };
